export default __webpack_public_path__ + "static/media/paris_picture.6e0fe297.jpg";